import Spinner from "components/Spinner";
import { Predicates } from "libraries/predicates/predicates";
import { useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useAxios from "utils/useAxios";
import {
  ItemNumberViewAttributes,
  ItemNumberViewHierarchy,
} from "../components/itemnumber-view";
import AuthContext from "context/AuthContext";
import useItemNumber from "../../../hooks/useItemNumber";
import { Button } from "react-bootstrap";
import ItemNumberValuesImportTable from "../../mpn/components/tcc-values-import/ItemNumberValuesImportTable";
import { ExpandableSection } from "routes/mpn/components/expandable-section";

const ItemnumberView = () => {
  const axios = useAxios();
  const authCtx = useContext(AuthContext);
  const hasPermission = authCtx?.hasPermission;
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const hasGlobalApproverPermission: boolean = hasPermission(
    "api.global_approver_tcc_request",
  );

  const { data: itemnumber, isLoading: isItemNumberInformationLoading } =
    useItemNumber({ id:searchParams.get("id") });

  return (
    <>
      {isItemNumberInformationLoading ||
      Predicates.isNullOrUndefined(itemnumber) ? (
        <Spinner />
      ) : (
        <>
          {/*@ts-ignore*/}
          <ItemNumberViewHierarchy itemNumberData={itemnumber} />
          {/*@ts-ignore*/}
          <ItemNumberViewAttributes itemNumberData={itemnumber} />

          <ExpandableSection
            title={"Item Number Composition"}
            sectionId={"3"}
            expandedByDefault={true}
            className="mb-2"
          >
            {/*@ts-ignore*/}
            <ItemNumberValuesImportTable
              isInApprovalProcess={false}
              isRevision={false}
              isViewOnly={true}
              //@ts-ignore
              composition={itemnumber?.tcc_compositions}
            />
          </ExpandableSection>

          {/*<ItemNumberViewComposition itemNumberData={itemnumber} />*/}
          {/*<ItemNumberViewHistorySection itemNumberData={itemnumber} />*/}

          <Button
            onClick={() =>
              navigate(`/mpn/create?should_create=true`, {
                state: {
                  itemNumber: itemnumber,
                  // @ts-ignore
                  global_product: itemnumber?.global_product,
                },
              })
            }
            className={"btn btn-primary"}
          >
            Create MPN
          </Button>
        </>
      )}
    </>
  );
};

export default ItemnumberView;
